import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Centered message + retry (Android `AttractionsErrorState`). The repo has no shared error
 * component; this is the feature-local one. Falls back to the generic error copy when no message is
 * supplied — the server's own error bodies are never shown to a guest.
 */
@Component({
    selector: 'app-attraction-error-state',
    template: `
    <div class="attr-error">
      <p class="attr-error-message">{{ message || ('attractions.error' | translate) }}</p>
      <button type="button" class="attr-error-retry" (click)="retry.emit()">
        {{ 'attractions.retry' | translate }}
      </button>
    </div>
  `,
    styles: [`
    :host { display: block; }
    .attr-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 32px;
      min-height: 60vh;
    }
    .attr-error-message {
      margin: 0 0 16px;
      font-size: 16px;
      color: var(--attr-on-surface-variant, #5A6B84);
    }
    .attr-error-retry {
      border: none;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      color: var(--attr-on-accent, #FFFFFF);
      background: var(--attr-accent, #0071EB);
      border-radius: 24px;
      padding: 12px 28px;
    }
  `],
    host: { class: 'attractions-scope' },
    standalone: false
})
export class AttractionErrorStateComponent {
  @Input() message: string | null = null;
  @Output() retry = new EventEmitter<void>();
}
